import React from 'react';
import * as customer from 'customer/data.js';
import { useQuery, useMutation, useQueryClient } from 'react-query';

export const useQueryListCustomerAccountsForDomain = (domain) => {
  const query = useQuery(
    ['listCustomerAccountsForDomain', domain], 
    ({ queryKey }) => {
      const [, domainId] = queryKey;
      return customer.listCustomerAccountsForDomain(null, domainId);
    }
  );
  return React.useMemo(() => ({ query }), [query]);
};

export const useQueryGetCustomerAccountDetails = ({ domain, type, id } = {}) => {
  const query = useQuery(
    ['getCustomerAccountDetails', domain, type, id], 
    ({ queryKey }) => {
      const [, domainId, accountType, accountId] = queryKey;
      return customer.getCustomerAccountDetails(null, domainId, accountType, accountId);
    }
  );
  return React.useMemo(() => ({ query }), [query]);
};

export const useQueryGetCustomerAccountMetadata = ({ domain, type, id } = {}) => {
  const query = useQuery(
    ['getCustomerAccountMetadata', domain, type, id], 
    ({ queryKey }) => {
      const [, domainId, accountType, accountId] = queryKey;
      return customer.getCustomerAccountMetadata(null, domainId, accountType, accountId);
    }
  );
  return React.useMemo(() => ({ query }), [query]);
};

export const useQueryGetCustomerInformation = (domain) => {
  const query = useQuery(
    ['getCustomerInformation', domain], 
    ({ queryKey }) => {
      const [, domainId] = queryKey;
      return customer.getCustomerInformation(null, domainId);
    }
  );
  return React.useMemo(() => ({ query }), [query]);
};

export const useQueryGetGCPAccessGrants = () => {
  const query = useQuery(['getGCPAccessGrants'], () => customer.getGCPAccessGrants());
  return React.useMemo(() => ({ query }), [query]);
};

export const useMutationSetGCPAccessGrant = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation(
    (projectId) => customer.setGCPAccessGrants(projectId), {
      onSuccess: () => {
        queryClient.invalidateQueries('getGCPAccessGrants');
      }
    }
  );

  return [mutation.mutate, mutation.isLoading];
};

export const useQueryGetTenantList = () => {
  const query = useQuery(['getTenantList'], () => customer.getTenantList());
  return React.useMemo(() => ({ query }), [query]);
};

export const useQueryGetAPICredentials = (userId, isRacker) => {
  const query = useQuery(
    ['getAPICredentials', userId, isRacker], 
    ({ queryKey }) => {
      const [, userIdParam, isRackerParam] = queryKey;
      return customer.getAPICredentials(null, userIdParam, isRackerParam);
    }
  );
  return React.useMemo(() => ({ query }), [query]);
};
